<template>
  <div class="tw-flex tw-gap-8 tw-items-start">
    <slot />
  </div>
</template>
